// extracted by mini-css-extract-plugin
export default {"item":"x0vMuyomRa7dtLv2wXLO"};